
import { useState, useEffect } from 'react';
import client from './api/HTTPClient';
import api from './api/apilist'
const timeStamp = Date.now() // 0

/*
 * TEMPORARY diagnostics for the ticket-grid hover/click lag investigation.
 * Opt-in via ?debugPerf=1 (see index.js). isPerfDebug() gates whether a
 * <Profiler onRender={onRenderDebug}> is mounted around the components under
 * suspicion, so this has zero cost for real users. Remove once resolved.
 */
export const isPerfDebug = () =>
  typeof window !== 'undefined' && window.location.search.includes('debugPerf');

let perfRenderCount = 0;

export const onRenderDebug = (id, phase, actualDuration, baseDuration, startTime, commitTime) => {
  perfRenderCount += 1;
  console.warn(
    `[perf] PROFILER #${perfRenderCount} "${id}" (${phase}): rendered in ${actualDuration.toFixed(1)}ms, committed at ${commitTime.toFixed(0)}ms since nav`
  );
};

export const getOidcStorageKey = () => {
  const authSettings = JSON.parse(localStorage.getItem('authSettings'));
  if (authSettings) {
    return `oidc.user:${authSettings.auth_server}:${authSettings.client_id}`;
  }
  return null;
};

export const getOidcInfo = () => {
  const key = getOidcStorageKey();
  if (key) {
    const oidc = JSON.parse(localStorage.getItem(key));
    return oidc;
  }
  return null;
};

export const getToken = () => {
  const oidc = getOidcInfo();
  if (oidc) {
    return oidc.id_token;
  }
  return null;
};

export const logoutSession = () => {
  return dispatch => {

    localStorage.removeItem('token');
    localStorage.removeItem('@customerId');
    localStorage.removeItem('@merchant_id');
    localStorage.removeItem('customer_type');

    dispatch({
      type: "UNSET_USER_DETAILS",
      result: ""
    })
  }

}

export const toggleStoreSelection = (value) => {
  return dispatch => {
    dispatch({
      type: "TOGGLE_MERCHANT_SELECTION",
      value: value
    })
  }
}
export const toggleIpayPinModal = (value, data=null) => {
  return dispatch => {
    dispatch({
      type: "TOGGLE_IPAY_PIN_MODAL",
      value: value,
      data: data,
    })
  }
}
export const togglemainloading = (value) => {
  return dispatch => {
    dispatch({
      type: "TOGGLE_MAIN_LOADING",
      value: value
    })
  }
}

export const displayCardBrand = (cardNum) => {
  if (cardNum) {
    // console.log(/^4[0-9]{6,}$/.test(cardNum), "visa")
    if (/^4[0-9]{6,}$/.test(cardNum)) {
      return "Visa"
    } else if (/^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$/.test(cardNum)) {
      return "Mastercard"
    } else if (/^3[47][0-9]{13}$/.test(cardNum)) {
      return "American Express"
    } else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(cardNum)) {
      return "Diners Club"
    } else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(cardNum)) {
      return "Discover"
    } else if (/^(?:2131|1800|35\d{3})\d{11}$/.test(cardNum)) {
      return "JCB"
    } else {
      return "Card"
    }
  }
  return " "
}

export const validateLoginSession = (closePinModal = false) => {


  return dispatch => {

    client.post(api.validateCutomer, {}, async function (error, result) {

      if (!error) {
        if (result && result.error == false) {

          const customer_type = localStorage.getItem("customer_type");

          localStorage.setItem('@customerId', result.result._id);
          dispatch({
            type: "SET_USER_DETAILS",
            result: result.result
          })
          if (closePinModal == true) {
            dispatch(toggleIpayPinModal(false))
          }

          if (!closePinModal) {
            if (customer_type == 2 && localStorage.getItem("@merchant_id")) {
              dispatch(validateStoreSession())
            } else {
              dispatch({
                type: "SET_ACCOUNT_ID",
                account_id: result.result._id
              })

            }
          }


        } else {
          if (result) {
            if (result.registered == false) {
              // return result;
            } else {
              // throw new Error(result.message)
            }
          }
          else {

          }

        }
      }
    });

  }

}

export const validateStoreSession = () => {

  const customer_id = localStorage.getItem("@customerId");
  const merchant_id = localStorage.getItem("@merchant_id");

  return dispatch => {

    client.post(api.validate_merchant, { merchant_id, admin_id: customer_id }, async function (error, result) {

      if (!error) {
        if (result && result.error == false) {

          dispatch({
            type: "SET_ACCOUNT_ID",
            account_id: merchant_id
          })

          dispatch({
            type: "SET_ACTIVE_STORE",
            result: result.result.merchant
          })

        } else {
          if (result) {
            if (result.registered == false) {
              // return result;
            } else {
              // throw new Error(result.message)
            }
          }
          else {

          }

        }
      }
    });

  }

}


export const getTimeZone = (company) => {

  try {

    if (company && company.timeZone) {
      return company.timeZone;
    } else {
      return "Australia/Sydney";
    }
  } catch {
    return "Australia/Sydney";
  }

}

export const renderImageWithTimestamp = (url) => {

  return url?.includes("dropbox") ? url?.replace('?', `?t=${timeStamp}&`) : url
}

export const useWindowSize = () => {

  const [dimension, setDimension] = useState({
    pageHeight: window.innerHeight,
    pageWidth: window.innerWidth
  });

  const updateDimensions = () => {
    setDimension({
      pageHeight: window.innerHeight,
      pageWidth: window.innerWidth
    })
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  return dimension;

}

export const fileDownload = (data, filename, mime, bom) => {
  var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
  var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were
      // revoked by closing the blob for which they were created.
      // These URLs will no longer resolve as the data backing
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
  } else {
      var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();

      // Fixes "webkit blob resource error 1"
      setTimeout(function() {
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
      }, 200)
  }
}

/**
 * Message posted to an embedder to ask it to navigate itself to the gateway.
 * The host side has to match this string exactly.
 */
export const GATEWAY_REDIRECT_MESSAGE = "linky-form:gateway-redirect";

/**
 * The handshake a host uses to announce itself. We post the probe; a host that
 * implements this answers with its own URL. Same names as the Next app's
 * useHostNav, and as mfr_linky_form_nav_script() on the WordPress side.
 */
export const HOST_PROBE_MESSAGE = "linky-form:nav-probe";
export const HOST_SUPPORTED_MESSAGE = "linky-form:nav-supported";

// How long to let a host answer GATEWAY_REDIRECT_MESSAGE before we take the
// top window ourselves. Short: this runs after the Pay click, with a spinner
// already up.
const GATEWAY_HOST_GRACE_MS = 150;

// How long to let that top navigation commit before assuming it was refused.
// Not short, because an accepted navigation does not unload us until the
// gateway responds, and firing the last resort on top of a redirect that is
// already in flight is worse than waiting.
const GATEWAY_TOP_NAV_GRACE_MS = 2000;

/** True when this document is running inside a frame. */
export const isEmbedded = () => {
  try {
    return window.top !== window.self;
  } catch (e) {
    // Reading window.top can throw against a cross-origin parent, and that
    // in itself means we are framed.
    return true;
  }
};

/**
 * Send the browser to an external payment gateway (Stripe Checkout).
 *
 * Use this instead of window.location.replace() for any URL that leaves the
 * app for a gateway. Stripe's hosted Checkout cannot run inside a cross-site
 * iframe: it needs its own cookies and storage, which Chrome partitions away
 * from a third-party frame. Stripe sends no frame-ancestors header, so nothing
 * is blocked outright — Checkout loads and then hangs on its grey skeleton
 * forever, which reads as a dead page rather than an error. That is what
 * meyerforrichmond.au/events/ hit: it frames linky.biz, so the Pay button
 * navigated the *frame* to Checkout and the buyer was stuck.
 *
 * So when we are framed the gateway has to open at the top level. Two routes,
 * in order:
 *
 *   1. Ask the embedder. A host that opts in navigates its own window, which
 *      carries no cross-origin restrictions at all. This is the reliable one.
 *   2. Take the top window ourselves. Location.replace() is one of the two
 *      members exposed across origins, so the call is permitted — but Chrome
 *      additionally wants a user gesture before a cross-origin frame may
 *      navigate its top, and the gesture from the Pay click may well have
 *      expired while the payment_session request was in flight. Hence (1)
 *      first, and hence the last resort below.
 *
 * If both are refused we navigate the frame, which is the old behaviour: the
 * buyer still gets the hanging Checkout page, but the button is never dead.
 *
 * @param {string} url Absolute gateway URL from the payment session.
 * @returns {boolean} False when there was no URL to go to.
 */
export const redirectToGateway = (url) => {
  if (!url) {
    return false;
  }

  // https only. A gateway URL always is, and the fallbacks below hand this
  // string straight to a Location, so a javascript: or data: value would run
  // as script — in the top window, at that. Note this is the only limit on
  // where the fallbacks go: an embedder's own allow-list governs the message
  // route, not a frame navigating its top, which any un-sandboxed iframe may
  // already do. The real constraint is that url comes from our own backend.
  if (typeof url !== "string" || url.indexOf("https://") !== 0) {
    return false;
  }

  if (!isEmbedded()) {
    window.location.replace(url);
    return true;
  }

  // 1. The host navigates itself. Sent to the parent only. targetOrigin is
  // "*" because we cannot know the embedder's origin from in here —
  // document.referrer is our own app by the time checkout is reached — and
  // the URL is only ever disclosed to the page already framing us. The host
  // is responsible for checking the sender and the URL before acting.
  try {
    window.parent.postMessage({ type: GATEWAY_REDIRECT_MESSAGE, url: url }, "*");
  } catch (e) {
    // No usable parent handle; fall through to the timers below.
  }

  // Whichever route wins, this document is discarded once it commits — the
  // host navigating itself unloads us with it, and so does taking the top
  // window. pagehide is how we know that started, and it is what keeps each
  // step below from piling on top of a redirect that is already happening.
  let leaving = false;
  const markLeaving = () => {
    leaving = true;
  };

  window.addEventListener("pagehide", markLeaving, true);
  window.addEventListener("beforeunload", markLeaving, true);

  // 2. If the host answered, we are already on our way out and this is a
  // no-op. Otherwise take the top window ourselves.
  setTimeout(() => {
    if (leaving) {
      return;
    }

    try {
      window.top.location.replace(url);
    } catch (e) {
      // Sandboxed away from the top; the last resort below covers it.
    }
  }, GATEWAY_HOST_GRACE_MS);

  // Chrome refuses a gestureless cross-origin top navigation by logging
  // rather than throwing, so the catch above cannot see it — a refusal and a
  // success look identical from in here, and only the unload tells them
  // apart. Still nothing? Then nothing above us moved: navigate the frame,
  // which is the old behaviour. Checkout will hang there, but the Pay button
  // is never simply dead.
  setTimeout(() => {
    if (leaving) {
      return;
    }

    window.location.replace(url);
  }, GATEWAY_HOST_GRACE_MS + GATEWAY_TOP_NAV_GRACE_MS);

  return true;
};


/**
 * The URL of the page framing this checkout, once it has told us.
 *
 * Needed for one thing: the cancel target of a Stripe Checkout session. The
 * server builds that from the Origin header of whoever created the payment
 * request, which inside an embed is our own iframe origin — so a buyer who
 * backs out of Stripe lands on linky.biz instead of the site they were
 * actually on. We cannot read the host's URL (different origin), so we ask,
 * and pass the answer to payment_session as cancel_url. The server only
 * honours it for hosts on its own allowlist, so a wrong or hostile answer
 * here changes nothing.
 *
 * Two ways in, because there are two ways to arrive here from someone else's
 * page. Framed, we ask and the host answers. Opened at top level from a frame
 * — which is how the events flow hands over, since this app cannot do its job
 * as a third party — there is no host to ask, so the URL rides along on
 * `embed_host` instead. See withEmbedHost() in the Next app.
 *
 * Returns null until a host answers, and forever on a host that does neither —
 * callers should simply omit cancel_url then and let the server keep its own.
 *
 * @returns {string|null} The embedder's URL, or null.
 */

/**
 * The embedding page's URL as handed to us on the query string.
 *
 * https only: the value ends up in an href on the receipt page. It is checked
 * again on the server against EMBED_RETURN_HOSTS, which is the actual gate —
 * anything not on that list is dropped there and changes nothing.
 *
 * @returns {string|null}
 */
const embedHostUrlFromQuery = () => {
  try {
    const raw = new URLSearchParams(window.location.search).get("embed_host");

    if (!raw) {
      return rememberedEmbedHost();
    }

    const parsed = new URL(raw);

    if (parsed.protocol !== "https:") {
      return null;
    }

    rememberEmbedHost(parsed.toString());

    return parsed.toString();
  } catch (e) {
    return null;
  }
};

/*
 * The query string does not survive the trip to the page that actually
 * creates the payment session. /paynow/:token sends the buyer on to
 * /:token/processTransaction with history.replace() and a bare pathname, so by
 * the time they pick PayPal or a card, `embed_host` is gone, no cancel_url is
 * sent, and the server falls back to the minisite — which is where PayPal's
 * "Return to seller" was taking buyers who started on the Duke's Events page.
 *
 * So it is remembered for the tab, keyed by the payment token, and read back
 * on any later page of the same payment. Keyed so that an unrelated payment
 * opened in the same tab later is not sent back to this one's host.
 */
const EMBED_HOST_KEY = "linky:embed_host:";

const paymentTokenFromPath = () => {
  const parts = window.location.pathname.split("/").filter(Boolean);

  if (parts[0] === "paynow" && parts[1]) {
    return parts[1];
  }

  if (parts[1] === "processTransaction" && parts[0]) {
    return parts[0];
  }

  return null;
};

const rememberEmbedHost = (url) => {
  const token = paymentTokenFromPath();

  if (!token) {
    return;
  }

  try {
    window.sessionStorage.setItem(EMBED_HOST_KEY + token, url);
  } catch (e) {
    // Storage blocked; this page still has it from the query string.
  }
};

const rememberedEmbedHost = () => {
  const token = paymentTokenFromPath();

  if (!token) {
    return null;
  }

  try {
    return window.sessionStorage.getItem(EMBED_HOST_KEY + token) || null;
  } catch (e) {
    return null;
  }
};

export const useEmbedHostUrl = () => {
  const [hostUrl, setHostUrl] = useState(() =>
    typeof window === "undefined" ? null : embedHostUrlFromQuery()
  );

  useEffect(() => {
    if (!isEmbedded()) {
      return undefined;
    }

    const onMessage = (event) => {
      if (event.source !== window.parent) return;
      if (event.data?.type !== HOST_SUPPORTED_MESSAGE) return;
      if (typeof event.data.href !== "string") return;

      setHostUrl(event.data.href);
    };

    window.addEventListener("message", onMessage);

    // The host's listener may not be attached when this frame mounts — the
    // meyerforrichmond.au embed is lazy-loaded — so ask a few times and then
    // stop rather than waiting forever.
    const probe = () => {
      try {
        window.parent.postMessage({ type: HOST_PROBE_MESSAGE }, "*");
      } catch (e) {
        // Sandboxed away from the parent; nothing else to try.
      }
    };

    probe();
    const retries = [setTimeout(probe, 300), setTimeout(probe, 1200)];

    return () => {
      window.removeEventListener("message", onMessage);
      retries.forEach(clearTimeout);
    };
  }, []);

  return hostUrl;
};

/*
 * ---------------------------------------------------------------------------
 * Auto height
 * ---------------------------------------------------------------------------
 *
 * An embedder frames us at a fixed height, because a cross-origin frame cannot
 * resize itself. This app is taller than any sensible fixed height and, worse,
 * carries its own scroll container — `.ipaypro_payments_process` is
 * `overflow: auto` on top of an inline `height: 100vh` — so a framed checkout
 * gives the buyer two scrollbars and a viewport-sized porthole onto the page
 * they are paying on.
 *
 * So we measure ourselves and post AUTO_HEIGHT_MESSAGE; a host that implements
 * it sizes the frame to that number, its own page scrolls, and we have nothing
 * left to scroll. A host that does not keeps its fixed height, and the only
 * difference is the neutralising CSS below.
 *
 * That CSS is the other half, and it is in public/index.html keyed on
 * `data-embed-autoheight` so it lands on the first paint. It has to undo
 * everything that measures against the viewport, because inside a frame sized
 * to its own content the viewport *is* that content: the scroll container
 * above (which would otherwise hide the overflow we are trying to measure),
 * and the mobile `90vh`/`55vh` blocks.
 *
 * `position: fixed` inside the frame stops tracking the buyer as a
 * consequence — the mobile pay footer (`._1gu8`) lands at the bottom of the
 * whole page instead of the bottom of the screen. There is no way around that
 * from in here; a frame with no scroll of its own has no screen to pin to.
 *
 * The host side is mfr_linky_form_nav_script() in the meyerforrichmond.au
 * theme (veto-child/inc/mfr-donation-form.php). The same protocol is
 * implemented frame-side in the Next app's utils/embedHostNav.ts — the message
 * names have to match all three.
 */
export const AUTO_HEIGHT_MESSAGE = "linky-form:height";
export const SCROLL_TOP_MESSAGE = "linky-form:scroll-top";

const AUTO_HEIGHT_ATTR = "data-embed-autoheight";

/*
 * Runaway guard: at most this many reports in this window, ever.
 *
 * Every `vh` left in the page is a feedback path — the host acts on our
 * number, that changes our layout, we measure again. They converge today, but
 * a future `vh` on a padding or a margin would not: it would grow without
 * bound until the host's own clamp, re-measuring the whole way.
 *
 * A window rather than a running total, because this hook is mounted once for
 * the whole app: a total would eventually be spent by a buyer expanding and
 * collapsing payment options, and auto height would quietly stop working
 * mid-checkout. Nothing legitimate reports forty times in five seconds.
 */
const AUTO_HEIGHT_BURST_LIMIT = 40;
const AUTO_HEIGHT_BURST_MS = 5000;

/**
 * The smallest height we will ever report.
 *
 * Plenty in here is sized against the viewport, and inside a frame sized to
 * its own content the viewport *is* the number we just sent: report a
 * fraction of it back and the frame shrinks, which shrinks the box, which
 * shrinks the frame. An absolute floor stops that walk. It used to floor at
 * the height the embedder framed us at instead, which stopped it too — and
 * also stopped the frame ever getting shorter than the host's guess, so a
 * checkout that needed 700px kept the other 300 as blank space.
 */
const AUTO_HEIGHT_MIN = 320;

/**
 * How long after mounting we refuse to report anything *shorter* than the
 * height we already have.
 *
 * Only about flicker: a checkout that paints inside this window goes straight
 * from the host's guess to its real height, with nothing in between. Past it,
 * an honest shrink is worth more than a smooth one.
 */
const AUTO_HEIGHT_SETTLE_MS = 1200;

/**
 * Ask the embedder to bring the frame's top edge back into view.
 *
 * A frame as tall as its content does not scroll, so our own
 * `window.scrollTo(0, 0)` on a route change moves nothing — the buyer stays
 * wherever the host page was left, which is now the middle of the page they
 * just opened. Called from ScrollToTop, alongside that scroll.
 */
export const requestHostScrollTop = () => {
  if (!isEmbedded()) {
    return;
  }

  try {
    window.parent.postMessage({ type: SCROLL_TOP_MESSAGE }, "*");
  } catch (e) {
    // Sandboxed away from the parent; nothing else to try.
  }
};

/**
 * Report this app's height to its embedder, and keep reporting as it changes.
 *
 * Mounted once, from App, so it covers every route: the buyer moves between
 * /paynow, /processTransaction and the customer form without this remounting.
 * No-op when we are not framed.
 */
export const useEmbedAutoHeight = () => {
  useEffect(() => {
    if (!isEmbedded()) {
      return undefined;
    }

    const root = document.documentElement;
    root.setAttribute(AUTO_HEIGHT_ATTR, "1");

    // Not shrinking below this until AUTO_HEIGHT_SETTLE_MS is up: the height
    // we are being framed at right now. See AUTO_HEIGHT_MIN for the floor that
    // applies after that.
    const settleFloor = window.innerHeight;
    const settleUntil = Date.now() + AUTO_HEIGHT_SETTLE_MS;

    let reported = 0;
    let pending = 0;
    let burst = 0;
    let burstStart = 0;
    let stopped = false;

    /*
     * The smallest height measured since the last quiet spell, and what we
     * fall back to if the runaway guard trips.
     *
     * A feedback path here always ratchets *up* — each report makes the
     * viewport taller, which makes the next measurement taller — so the last
     * height before the guard trips is the worst one in the run, and freezing
     * there is how a frame ends up a screenful of content and nine thousand
     * pixels of blank. The first measurement of the run is the one taken
     * before we had moved anything, so that is what we leave behind.
     */
    let smallest = Infinity;

    const measure = () => {
      const body = document.body;

      if (!body) {
        return 0;
      }

      /*
       * body.scrollHeight, not documentElement's: the root element's is
       * floored at the viewport height, and in here the viewport *is* the
       * height we are trying to set — so a page that got shorter could never
       * say so, and the frame would only ever ratchet up.
       */
      const floor =
        Date.now() < settleUntil
          ? Math.max(AUTO_HEIGHT_MIN, settleFloor)
          : AUTO_HEIGHT_MIN;

      return Math.ceil(
        Math.max(body.scrollHeight, body.getBoundingClientRect().height, floor)
      );
    };

    const report = () => {
      pending = 0;

      const height = measure();

      // Sub-pixel churn as fonts swap and the Stripe iframes settle would
      // otherwise post on every single observer callback.
      if (!height || Math.abs(height - reported) < 2) {
        return;
      }

      if (stopped) {
        return;
      }

      const now = Date.now();

      if (now - burstStart > AUTO_HEIGHT_BURST_MS) {
        burstStart = now;
        burst = 0;
        smallest = Infinity;
      }

      burst += 1;

      if (height < smallest) {
        smallest = height;
      }

      if (burst > AUTO_HEIGHT_BURST_LIMIT) {
        // Something is feeding back. Stop driving the frame — but hand back
        // the smallest height of the run first, so what is left behind is the
        // page as it was before we started moving it rather than the tallest
        // step of the runaway.
        stopped = true;

        if (smallest < height) {
          reported = smallest;

          try {
            window.parent.postMessage(
              { type: AUTO_HEIGHT_MESSAGE, height: smallest },
              "*"
            );
          } catch (e) {
            // Sandboxed away from the parent; nothing else to try.
          }
        }

        return;
      }

      reported = height;

      try {
        window.parent.postMessage(
          { type: AUTO_HEIGHT_MESSAGE, height: height },
          "*"
        );
      } catch (e) {
        // Sandboxed away from the parent; nothing else to try.
      }
    };

    /*
     * A timer rather than requestAnimationFrame: an iframe does not always get
     * animation frames — Chrome throttles them for a frame that is offscreen
     * or in a background tab, and the very first height then never gets sent
     * at all, which is exactly the case that matters. The delay also coalesces
     * the burst of observer callbacks that Stripe's own iframes arrive in.
     */
    const schedule = () => {
      if (pending) {
        return;
      }

      pending = window.setTimeout(report, 60);
    };

    schedule();

    const observer =
      typeof ResizeObserver === "function" ? new ResizeObserver(schedule) : null;

    if (observer && document.body) {
      observer.observe(document.body);
    }

    /*
     * The observer covers content changes, and resize covers the host acting
     * on what we sent. The timers are for what neither sees in time: Stripe
     * Elements mounting into their own frames, and browsers with no
     * ResizeObserver at all.
     */
    const timers = [400, 1200, 2500, 4000].map(function (ms) {
      return window.setTimeout(schedule, ms);
    });

    window.addEventListener("load", schedule);
    window.addEventListener("resize", schedule);

    return () => {
      if (observer) {
        observer.disconnect();
      }

      timers.forEach(clearTimeout);
      window.removeEventListener("load", schedule);
      window.removeEventListener("resize", schedule);

      if (pending) {
        clearTimeout(pending);
      }

      root.removeAttribute(AUTO_HEIGHT_ATTR);
    };
  }, []);
};
